import React from "react";
import PropTypes from "prop-types";
import { ButtonBase } from "@material-ui/core";
import { useStyles } from "./location-tree.style";

export function ExpandToggle({ isExpanded, onToggle, nodeId }) {
  const classes = useStyles();
  return (
    <ButtonBase
      onClick={(event) => {
        event.stopPropagation();
        onToggle?.(nodeId);
      }}
      className={classes.expandToggle}
    >
      {isExpanded ? "\u25BC" : "\u25B6"}
    </ButtonBase>
  );
}

ExpandToggle.propTypes = {
  isExpanded: PropTypes.bool,
  onToggle: PropTypes.func,
  nodeId: PropTypes.string,
};

ExpandToggle.defaultProps = {
  isExpanded: false,
  onToggle: undefined,
  nodeId: undefined,
};
